<template>
    <div class="col-6">
        <FormField :labelName="$t('company')" fieldName="Company_Name" v-model="header" fieldClass="col-6" labelClass="col-4">
            <CustomSelect class="p-inputtext-sm" v-model="header.Company_Id" :url="this.$API_URL + 'list/company'" :minLength="0" :params="{ }" v-if="header && oldStyle" :disabled="true" />
            <CustomSelect class="p-inputtext-sm" v-model="header.Company_Code" :url="this.$API_URL + 'list/company_code'" :minLength="0" :params="{ }" v-if="header && !oldStyle" :disabled="true" />
        </FormField>

        <FormField :labelName="$t('product_category')" fieldName="Business_Segment_Name" v-model="header" fieldClass="col-6" labelClass="col-4">
            <CustomSelect class="p-inputtext-sm" v-model="header.Business_Segment_Id" :url="this.$API_URL + 'list/business_segment'" :minLength="0" :params="{ }" v-if="header && oldStyle" :disabled="true" />
            <CustomSelect class="p-inputtext-sm" v-model="header.Product_Category" :url="this.$API_URL + 'list/business_segment_code'" :minLength="0" :params="{ }" v-if="header && !oldStyle" :disabled="true" />
        </FormField>

        <FormField :labelName="$t('plant')" fieldName="Doc_Date" v-model="header" fieldClass="col-6" labelClass="col-4">
            <CustomSelect class="p-inputtext-sm" v-model="header.Plant_Code" :url="this.$API_URL + 'list/plant'" :minLength="0" :params="{ }" v-if="header && oldStyle" :disabled="true" />
            <CustomSelect class="p-inputtext-sm" v-model="header.Plant" :url="this.$API_URL + 'list/plant'" :minLength="0" :params="{ }" v-if="header && !oldStyle" :disabled="true" />
        </FormField>

        <FormField :labelName="$t('order_type')" fieldName="Order_Type" v-model="header" fieldClass="col-6" labelClass="col-4">
            <CustomSelect class="p-inputtext-sm" v-model="header.Order_Type_Id" :url="this.$API_URL + 'list/order_type'" :minLength="0" :params="{ }" v-if="header & oldStyle" :disabled="true" @change="onChangeOrderType"/>
            <CustomSelect class="p-inputtext-sm" v-model="header.Order_Type" :url="this.$API_URL + 'list/order_type_code'" :minLength="0" :params="{ }" v-if="header && !oldStyle" :disabled="true" @change="onChangeOrderType"/>
        </FormField>

        <FormField :labelName="useSOrg ? $t('sales_org') : $t('purchase_org')" fieldName="Purchase_Organization_Code" v-model="header" fieldClass="col-6" labelClass="col-4">
            <CustomSelect class="p-inputtext-sm" v-model="header.Sales_Organization_Id" :url="this.$API_URL + 'list/sales_organiztion'" :minLength="0" :params="{ }" v-if="header && oldStyle && useSOrg" :disabled="true" />
            <CustomSelect class="p-inputtext-sm" v-model="header.Purchase_Organization_Code" :url="this.$API_URL + 'list/purchase_organization'" :minLength="0" :params="{ }" v-if="header && oldStyle && usePOrg" :disabled="true"  />

            <CustomSelect class="p-inputtext-sm" v-model="header.Sales_Organization" :url="this.$API_URL + 'list/sales_organization_code'" :minLength="0" :params="{ }" v-if="header && !oldStyle && useSOrg" :disabled="true" />
            <CustomSelect class="p-inputtext-sm" v-model="header.Purchase_Organization" :url="this.$API_URL + 'list/purchase_organization'" :minLength="0" :params="{ }" v-if="header && !oldStyle && usePOrg" :disabled="true"  />
        </FormField>

        <FormField :labelName="$t('order_no')" fieldName="Order_No" v-model="header" fieldClass="col-6" labelClass="col-4">
            <InputText name="Order_No" v-model="orderNo" type="text" v-if="header" :disabled="true" />
        </FormField>

        <FormField :labelName="$t('sap_no')" fieldName="SAP_No" v-model="header" fieldClass="col-6" labelClass="col-4">
            <InputText name="SAP_No" v-model="header.SAP_No" type="text" v-if="header && oldStyle" :disabled="true" />
            <InputText name="SAP_No" v-model="header.Document_No" type="text" v-if="header && !oldStyle" :disabled="true" />
        </FormField>

        <FormField :labelName="$t('distribution')" fieldName="Distribution" v-model="header" fieldClass="col-6" labelClass="col-4" v-if="useDistribution">
            <CustomSelect class="p-inputtext-sm" v-model="header.Distribution" :url="this.$API_URL + 'list/lookup'" :minLength="0" :params="{ group: $LOOKUP_GROUP.DISTRIBUTION }" v-if="header" :disabled="true" />
        </FormField>

        <FormField :labelName="$t('incoterm')" fieldName="Incoterm" v-model="header" fieldClass="col-6" labelClass="col-4">
            <CustomSelect class="p-inputtext-sm" v-model="header.Incoterm_Id" :url="this.$API_URL + 'list/incoterm'" :minLength="0" :params="{ }" v-if="header && oldStyle" :disabled="true" />
            <CustomSelect class="p-inputtext-sm" v-model="header.Incoterm" :url="this.$API_URL + 'list/incoterm_code'" :minLength="0" :params="{ }" v-if="header && !oldStyle" :disabled="true" />
        </FormField>

        <FormField :labelName="$t('incoterm2')" fieldName="Incoterm2" v-model="header" fieldClass="col-6" labelClass="col-4">
            <InputText name="Incoterm2" v-model="header.Incoterm2" v-if="header" :disabled="true"/>
        </FormField>

        <FormField :labelName="$t('factory')" fieldName="Warehouse_Code" v-model="header" fieldClass="col-6" labelClass="col-4">
            <CustomSelect class="p-inputtext-sm" v-model="header.Warehouse_Code" :url="this.$API_URL + 'list/warehouse'" :minLength="0" :params="{ }" v-if="header" :disabled="true" />
        </FormField>
        
    </div>
    <div class="col-6">
        <FormField :labelName="$t('doc_type')" fieldName="Document_Type" v-model="header" fieldClass="col-6" labelClass="col-4">
            <CustomSelect class="p-inputtext-sm" v-model="header.Document_Type" :url="this.$API_URL + 'list/lookup'" :minLength="0" :params="{ group: $LOOKUP_GROUP.DOCUMENT_TYPE }" v-if="header" :disabled="true"/>
        </FormField>

        <FormField :labelName="useCustomer ? $t('customer') : $t('vendor')" fieldName="Customer_Vendor_Name" v-model="header" fieldClass="col-6" labelClass="col-4">
            <CustomSelect class="p-inputtext-sm" v-model="header.Vendor_Code" :url="this.$API_URL + 'list/customer_code'" :minLength="0" :params="{ company: header.Company_Code}" v-if="header && oldStyle && useCustomer" :disabled="true" @init="onChangeCustomerVendor"/>
            <CustomSelect class="p-inputtext-sm" v-model="header.Customer_Code" :url="this.$API_URL + 'list/vendor'" :minLength="0" :params="{ company: header.Company_Code}" v-if="header && oldStyle && !useCustomer" :disabled="true" @init="onChangeCustomerVendor"/>

            <CustomSelect class="p-inputtext-sm" v-model="header.Customer_Vendor_Code" :url="this.$API_URL + 'list/customer_code'" :minLength="0" :params="{ company: header.Company_Code}" v-if="header && useCustomer" :disabled="true" @init="onChangeCustomerVendor"/>
            <CustomSelect class="p-inputtext-sm" v-model="header.Customer_Vendor_Code" :url="this.$API_URL + 'list/vendor'" :minLength="0" :params="{ }" v-if="header && !useCustomer" :disabled="true" @init="onChangeCustomerVendor"/>
        </FormField>

        <FormField :labelName="$t('address')" fieldName="Customer_Vendor_Address" v-model="header" fieldClass="col-6" labelClass="col-4">
            <Textarea name="Customer_Vendor_Address" v-model="customerVendorAddress" v-if="header" :disabled="true" :autoResize="true"/>
        </FormField>

        <FormField :labelName="$t('valid_from')" fieldName="Valid_From" v-model="header" fieldClass="col-6" labelClass="col-4">
            <DatePicker  v-model="header.Valid_From" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="header" :disabled="mode != this.$FORM_MODE_CREATE" />
        </FormField>

        <FormField :labelName="$t('valid_to')" fieldName="Valid_To" v-model="header" fieldClass="col-6" labelClass="col-4">
            <DatePicker  v-model="header.Valid_To" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="header" :disabled="mode != this.$FORM_MODE_CREATE" />
        </FormField>

        <FormField :labelName="$t('do_bl_no')" fieldName="Delivery_Order_No" v-if="useEstate" v-model="header" fieldClass="col-6" labelClass="col-4">
            <InputText name="Delivery_Order_No" v-model="header.Delivery_Order_No" type="text" v-if="header" :disabled="mode != this.$FORM_MODE_CREATE" />
        </FormField>

        <FormField :labelName="$t('ln_sto_no')" fieldName="LN_STO_No" v-model="header" fieldClass="col-6" labelClass="col-4" v-if="useEstate">
            <InputText name="LN_STO_No" v-model="header.LN_STO_No" type="text" v-if="header" :disabled="mode != this.$FORM_MODE_CREATE" />
        </FormField>

        <FormField :labelName="$t('po_no')" fieldName="PO_No" v-model="header" fieldClass="col-6" labelClass="col-4" v-if="useEstate">
            <InputText name="PO_No" v-model="header.PO_No" type="text" v-if="header" :disabled="mode != this.$FORM_MODE_CREATE" />
        </FormField>

        <FormField :labelName="$t('estate')" fieldName="Estate" v-if="useEstate" v-model="header" fieldClass="col-6" labelClass="col-4">
            <InputText name="Estate" v-model="header.Estate" type="text" v-if="header" :disabled="true" />
        </FormField>

        <FormField :labelName="$t('ln_do_third_party')" fieldName="LN_DO_Third_Party" v-model="header" fieldClass="col-6" labelClass="col-4" v-if="useLN">
            <InputText name="LN_DO_Third_Party" v-model="header.LN_DO_Third_Party" type="text" v-if="header" :disabled="mode != this.$FORM_MODE_CREATE" />
        </FormField>

        <FormField :labelName="$t('ln_so_no')" fieldName="LN_SO_No" v-model="header" fieldClass="col-6" labelClass="col-4" v-if="useLN">
            <InputText name="LN_SO_No" v-model="header.LN_SO_No" type="text" v-if="header" :disabled="mode != this.$FORM_MODE_CREATE" />
        </FormField>
        
        <FormField :labelName="$t('ln_sto_no')" fieldName="LN_STO_No" v-model="header" fieldClass="col-6" labelClass="col-4" v-if="useLN">
            <InputText name="LN_STO_No" v-model="header.LN_STO_No" type="text" v-if="header" :disabled="mode != this.$FORM_MODE_CREATE" />
        </FormField>

        <FormField :labelName="$t('collective_ln')" fieldName="Collective_LN" v-model="header" fieldClass="col-6" labelClass="col-4" v-if="useLN">
            <InputText name="Collective_LN" v-model="header.Collective_LN" type="text" v-if="header" :disabled="mode != this.$FORM_MODE_CREATE" />
        </FormField>

        <FormField :labelName="$t('delivery_address')" fieldName="Delivery_Address" v-model="header" fieldClass="col-6" labelClass="col-4">
            <Textarea name="Delivery_Address" v-model="header.Delivery_Address"  v-if="header" :disabled="true" />
        </FormField>
<!-- 
        <FormField :labelName="$t('remarks')" fieldName="Remarks" v-model="header" fieldClass="col-6" labelClass="col-4">
            <Textarea name="Remarks" v-model="header.Remarks"  v-if="header" :disabled="true" />
        </FormField> -->
    </div>

<!-- 
    
 <div class="col-6">
        <FormField :labelName="$t('company')" fieldName="Company_Name" v-model="header" fieldClass="col-6" labelClass="col-4">
            <CustomSelect class="p-inputtext-sm" v-model="header.Company_Id" :url="this.$API_URL + 'list/company'" :minLength="0" :params="{ }" v-if="header && oldStyle" :disabled="true" />
            <Textarea name="Company_Name" v-model="header.Company_Name" v-if="header && !oldStyle" :disabled="true" :autoResize="true"/>
        </FormField>

        <FormField :labelName="$t('product_category')" fieldName="Business_Segment_Name" v-model="header" fieldClass="col-6" labelClass="col-4">
            <CustomSelect class="p-inputtext-sm" v-model="header.Business_Segment_Id" :url="this.$API_URL + 'list/business_segment'" :minLength="0" :params="{ }" v-if="header && oldStyle" :disabled="true" />
            <Textarea name="Business_Segment_Name" v-model="header.Business_Segment_Name" v-if="header && !oldStyle" :disabled="true" :autoResize="true"/>
        </FormField>

        <FormField :labelName="$t('plant')" fieldName="Doc_Date" v-model="header" fieldClass="col-6" labelClass="col-4">
            <CustomSelect class="p-inputtext-sm" v-model="header.Plant_Code" :url="this.$API_URL + 'list/plant'" :minLength="0" :params="{ }" v-if="header && oldStyle" :disabled="true" />
            <Textarea name="Plant_Name" v-model="header.Plant_Name" v-if="header && !oldStyle" :disabled="true" :autoResize="true"/>
        </FormField>

        <FormField :labelName="$t('order_type')" fieldName="Order_Type" v-model="header" fieldClass="col-6" labelClass="col-4">
            <CustomSelect class="p-inputtext-sm" v-model="header.Order_Type_Id" :url="this.$API_URL + 'list/order_type'" :minLength="0" :params="{ }" v-if="header" :disabled="!isCreate"/>
        </FormField>

        <FormField :labelName="useCustomer ? $t('sales_org') : $t('purchase_org')" fieldName="Purchase_Organization_Code" v-model="header" fieldClass="col-6" labelClass="col-4">
            <CustomSelect class="p-inputtext-sm" v-model="header.Sales_Organization_Id" :url="this.$API_URL + 'list/sales_organiztion'" :minLength="0" :params="{ }" v-if="header && oldStyle && useCustomer" :disabled="true" />
            <CustomSelect class="p-inputtext-sm" v-model="header.Purchase_Organization_Code" :url="this.$API_URL + 'list/purchase_organization'" :minLength="0" :params="{ }" v-if="header && oldStyle && !useCustomer" :disabled="true" />
            <Textarea name="Sales_Organization_Name" v-model="header.Sales_Organization_Name" v-if="header && !oldStyle && useCustomer" :disabled="true" :autoResize="true"/>
            <Textarea name="Purchase_Organization_Name" v-model="header.Purchase_Organization_Name" v-if="header && !oldStyle && !useCustomer" :disabled="true" :autoResize="true"/>
        </FormField>

        <FormField :labelName="$t('order_no')" fieldName="Order_No" v-model="header" fieldClass="col-6" labelClass="col-4">
            <InputText name="Order_No" v-model="header.Order_No" type="text" v-if="header" :disabled="true" />
        </FormField>

        <FormField :labelName="$t('sap_no')" fieldName="SAP_No" v-model="header" fieldClass="col-6" labelClass="col-4">
            <InputText name="SAP_No" v-model="header.SAP_No" type="text" v-if="header && oldStyle" :disabled="true" />
            <Textarea name="SAP_No" v-model="header.SAP_No" v-if="header && !oldStyle" :disabled="true" :autoResize="true"/>
        </FormField>

        <FormField :labelName="$t('distribution')" fieldName="Distribution" v-model="header" fieldClass="col-6" labelClass="col-4">
            <CustomSelect class="p-inputtext-sm" v-model="header.Distribution" :url="this.$API_URL + 'list/lookup'" :minLength="0" :params="{ group: $LOOKUP_GROUP.DISTRIBUTION }" v-if="header && oldStyle" :disabled="true" />
            <Textarea name="Distribution_Name" v-model="header.Distribution" v-if="header && !oldStyle" :disabled="true" :autoResize="true"/>
        </FormField>

        <FormField :labelName="$t('incoterm')" fieldName="Incoterm" v-model="header" fieldClass="col-6" labelClass="col-4">
            <CustomSelect class="p-inputtext-sm" v-model="header.Incoterm_Id" :url="this.$API_URL + 'list/incoterm'" :minLength="0" :params="{ }" v-if="header && oldStyle" :disabled="true" />
            <Textarea name="Incoterm_Name" v-model="header.Incoterm_Name" v-if="header && !oldStyle" :disabled="true" :autoResize="true"/>
        </FormField>

        <FormField :labelName="$t('incoterm2')" fieldName="Incoterm2" v-model="header" fieldClass="col-6" labelClass="col-4">
            <Textarea name="Incoterm2" v-model="header.Incoterm2" v-if="header" :disabled="true" :autoResize="true"/>
        </FormField>

        <FormField :labelName="$t('factory')" fieldName="Warehouse_Code" v-model="header" fieldClass="col-6" labelClass="col-4">
            <CustomSelect class="p-inputtext-sm" v-model="header.Warehouse_Code" :url="this.$API_URL + 'list/warehouse'" :minLength="0" :params="{ }" v-if="header" :disabled="true" />
        </FormField>
        
    </div>
    <div class="col-6">
        <FormField :labelName="$t('doc_type')" fieldName="Document_Type" v-model="header" fieldClass="col-6" labelClass="col-4">
            <CustomSelect class="p-inputtext-sm" v-model="header.Document_Type" :url="this.$API_URL + 'list/lookup'" :minLength="0" :params="{ group: $LOOKUP_GROUP.DOCUMENT_TYPE }" v-if="header" :disabled="true"/>
        </FormField>

        <FormField :labelName="$t('wb_trans_type')" fieldName="WB_Trans_Type" v-model="header" fieldClass="col-6" labelClass="col-4">
            <CustomSelect class="p-inputtext-sm" v-model="header.WB_Trans_Type" :url="this.$API_URL + 'list/wb_trans_type'" :minLength="0" :params="{ }" v-if="header" :disabled="true"/>
        </FormField>

        <FormField :labelName="useCustomer ? $t('customer') : $t('vendor')" fieldName="Customer_Vendor_Name" v-model="header" fieldClass="col-6" labelClass="col-4">
            <Textarea name="Customer_Vendor_Name" v-model="header.Customer_Vendor_Name" v-if="header && !oldStyle" :disabled="true" :autoResize="true"/>
            <CustomSelect class="p-inputtext-sm" v-model="header.Vendor_Code" :url="this.$API_URL + 'list/customer_code'" :minLength="0" :params="{ company: header.Company_Code}" v-if="header && oldStyle && useCustomer" :disabled="true" />
            <CustomSelect class="p-inputtext-sm" v-model="header.Customer_Code" :url="this.$API_URL + 'list/vendor'" :minLength="0" :params="{ company: header.Company_Code}" v-if="header && oldStyle && useVendor" :disabled="true" />
        </FormField>

        <FormField :labelName="$t('address')" fieldName="Customer_Vendor_Address" v-model="header" fieldClass="col-6" labelClass="col-4">
            <Textarea name="Customer_Vendor_Address" v-model="header.Customer_Vendor_Address" v-if="header" :disabled="true" :autoResize="true"/>
        </FormField>

        <FormField :labelName="$t('ln_do_third_party')" fieldName="LN_DO_Third_Party" v-model="header" fieldClass="col-6" labelClass="col-4">
            <InputText name="LN_DO_Third_Party" v-model="header.LN_SO_No" type="text" v-if="header" :disabled="mode != this.$FORM_MODE_CREATE" />
        </FormField>

        <FormField :labelName="$t('ln_so_no')" fieldName="LN_SO_No" v-model="header" fieldClass="col-6" labelClass="col-4">
            <InputText name="LN_SO_No" v-model="header.LN_SO_No" type="text" v-if="header" :disabled="mode != this.$FORM_MODE_CREATE" />
        </FormField>
        
        <FormField :labelName="$t('ln_sto_no')" fieldName="LN_STO_No" v-model="header" fieldClass="col-6" labelClass="col-4">
            <InputText name="LN_STO_No" v-model="header.LN_SO_No" type="text" v-if="header" :disabled="mode != this.$FORM_MODE_CREATE" />
        </FormField>

        <FormField :labelName="$t('collective_ln')" fieldName="Collective_LN" v-model="header" fieldClass="col-6" labelClass="col-4">
            <InputText name="Collective_LN" v-model="header.Collective_LN" type="text" v-if="header" :disabled="mode != this.$FORM_MODE_CREATE" />
        </FormField>

        <FormField :labelName="$t('delivery_address')" fieldName="Delivery_Address" v-model="header" fieldClass="col-6" labelClass="col-4">
            <Textarea name="Delivery_Address" v-model="header.Delivery_Address"  v-if="header" :disabled="true" />
        </FormField>

        <FormField :labelName="$t('remarks')" fieldName="Remarks" v-model="header" fieldClass="col-6" labelClass="col-4">
            <Textarea name="Remarks" v-model="header.Remarks"  v-if="header" :disabled="true" />
        </FormField>
    </div> -->


</template>
<script>
    export default{

        props:{
            header:{
                type:Object,
                default: null
            },
            oldStyle:{
                type:Boolean,
                default:false
            },
            mode:{
                type:String,
                default:""
            },
            orderType:{
                type:Object,
                default:null
            },
            orderNo:{
                type:String,
                default: ""
            },
        },
        data(){
            return {
                customerVendorAddress: ""
            }
        },
        mounted(){

        },
        create() {
            console.log(this.header);
        },
        methods:{
            onVendorCustomerChange(){
                var code = "";
                var self = this;

                if(oldStyle){
                    code = useCustomer ? header.Customer_Code : header.Vendor_Code;
                }
                else{
                    code = header.Customer_Vendor_Code;
                }
                
                this.$axios.get(this.$UTIL_URL + `customer_vendor_address?code=${code}&type=${useVendor ? "VENDOR" : "CUSTOMER"}&hide=true` )
                    .then((response) => {       
                        if(response.data.success){
                            self.customerVendorAddress = response.data.data;

                        }
                    })      
                    .catch((error) => {})
            }
        },
        computed:{
            useCustomer(){
                return this.orderType ? this.orderType.Use_Customer : false;
            },
            useVendor(){
                return this.orderType ? this.orderType.Use_Vendor : false;
            },
            useDistribution(){
                return this.orderType ? this.orderType.Use_Distribution : false;
            },
            useEstate(){
                return this.orderType ? this.orderType.Use_GR : false;
            },
            usePOrg(){
                return this.orderType ? this.orderType.Use_POrg : false;
            },
            useSOrg(){
                return this.orderType ? this.orderType.Use_SOrg : false;
            },
            useLN(){
                return this.orderType ? this.orderType.Use_LN: false;
            }
        }
    }

</script>

